export const typeDisplayLabels = {
  text: 'Short Answer',
  textarea: 'Long Answer',
  number: 'Number Field',
  dropdown: 'Dropdown',
  checkbox: 'Checkbox',
  date: 'Date',
  birthdate: 'Birth Date',
  phone: 'Phone',
  email: 'Email',
  url: 'URL',
  country: 'Country',
  player_position: 'Player Position',
} as const

export type QuestionType = keyof typeof typeDisplayLabels
